import React from "react";
// material-ui
import {
  Button,
  Dialog,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material";

// project import
import Avatar from "../@extended/Avatar";
import { PopupTransition } from "../@extended/Transitions";

// assets
import { DeleteFilled } from "@ant-design/icons";
import { FormattedMessage } from "react-intl";

interface ReusableDeleteDialogProps {
  open: boolean;
  handleClose: () => void;
  handleDelete: () => void;
  title?: string;
  isDeleting?: boolean;
  dialogContent?: React.ReactNode;
}

// ==============================|| REUSABLE DELETE DIALOG ||============================== //

export default function ReusableDeleteDialog({
  open,
  handleClose,
  handleDelete,
  title,
  isDeleting,
  dialogContent,
}: ReusableDeleteDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      keepMounted
      TransitionComponent={PopupTransition}
      maxWidth="xs"
      aria-labelledby="column-delete-title"
      aria-describedby="column-delete-description"
    >
      <DialogContent sx={{ mt: 2, my: 1 }}>
        <Stack alignItems="center" spacing={3.5}>
          <Avatar
            color="error"
            sx={{ width: 72, height: 72, fontSize: "1.75rem" }}
          >
            <DeleteFilled />
          </Avatar>
          <Stack spacing={2}>
            <Typography variant="h4" align="center">
              <FormattedMessage id="Are you sure you want to delete" />
            </Typography>
            {dialogContent || (
              <Typography align="center">
                <FormattedMessage id="By deleting" />
                {title && (
                  <Typography variant="subtitle1" component="span">
                    {" "}
                    "{title}"{" "}
                  </Typography>
                )}
                <FormattedMessage id="all data assigned to that category will also be deleted" />
              </Typography>
            )}
          </Stack>

          <Stack direction="row" spacing={2} sx={{ width: 1 }}>
            <Button
              fullWidth
              onClick={handleClose}
              color="secondary"
              variant="outlined"
            >
              <FormattedMessage id="cancel" />
            </Button>
            <Button
              fullWidth
              color="error"
              variant="contained"
              onClick={handleDelete}
              autoFocus
              disabled={isDeleting}
            >
              <FormattedMessage id="Delete" />
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
